export default "__VITE_ASSET__2641f788__"